import serverCall from "../serverCall";

const getGlobalRanking = (gameName, period, filterType, globalRankingType) => {
  try {
    const response = serverCall.get(
      `/scores/globalRanking/bestCountry?gameName=${gameName}&period=${period}&filterType=${filterType}&globalRankingType=${globalRankingType}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getLeaderboard = (country, age, gameName, period,page,limit) => {
  try {
    const response = serverCall.get(
      `/scores/newLeaderboard/data?country=${country}&age=${age}&gameName=${gameName}&period=${period}&page=${page}&limit=${limit}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const GlobalRankingService = {
  getGlobalRanking,
  getLeaderboard,
};

export default GlobalRankingService;
